import { PaymentStatus } from './../../models/payment-status.enum';
import { ReportType } from './../../models/report-type.enum';
import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ElementRef
} from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { Observable } from 'rxjs/Observable';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { RsvpBulkComponent } from '../rsvp-bulk/rsvp-bulk.component';
import { RsvpFormComponent } from '../rsvp-form/rsvp-form.component';
import { PaymentStore } from '../../service/payment.store';
import { MatchTypeEnum } from '../../models/match-type.enum';
import { ReservationCompare } from '../../models/reservation-compare';
import { List } from 'immutable';
import { PdfService } from '../../../shared/pdf/pdf.service';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { ReportService } from '../../service/report.service';
import { ResponseUtil } from '../../../shared/utils/response-util';

@Component({
  selector: 'pioneer-add-rsvp',
  templateUrl: './add-rsvp.component.html'
})
export class AddRsvpComponent implements OnInit {

  @Input()
  showDownloadDropdown: boolean;

  @ViewChild(RsvpBulkComponent)
  rsvpBulk: RsvpBulkComponent;

  @ViewChild(RsvpFormComponent)
  rsvpComponent: RsvpFormComponent;

  onyxEvent: OnyxEvent;

  fileExtensions: Array<string>;

  isUploadInProgress: boolean;
  isAddRsvpCollapsed: boolean;
  hasFinalPayment: boolean;
  isRequestPaymentRejected: boolean;

  public rsvpCompareList: Observable<List<ReservationCompare>>;

  @ViewChild('file') fileInput: ElementRef;

  @Input()
  summarySelected: boolean;

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  constructor(private environment: EnvironmentConfiguration,
              private flashMessagesService: FlashMessagesService,
              private paymentStore: PaymentStore,
              private pdfService: PdfService,
              private reservationCompareStore: ReservationCompareStore,
              private reportService: ReportService
  ) { }

  ngOnInit() {

    this.isUploadInProgress = false;
    this.isAddRsvpCollapsed = true;
    this.isRequestPaymentRejected = false;

    if (!this.onyxEvent) {
      throw new Error('The "event" attribute must be specified to use the AddRsvpComponent component');
    }

    if (!this.onyxEvent.eventId) {
      this.hasFinalPayment = false;
    } else {
      this.paymentStore.getLatestFinalPayment().take(1).subscribe(lastFinalPayment => {
        let value = lastFinalPayment && lastFinalPayment.eventPaymentId;
        this.hasFinalPayment =  Boolean(value);
        this.isRequestPaymentRejected = !!lastFinalPayment && lastFinalPayment.status === PaymentStatus.REQUEST_REJECTED;
      });
    }

    this.fileExtensions = this.environment.rsvps.acceptedFileExtensions;

    this.rsvpCompareList = this.reservationCompareStore.getReservationList();
  }

  addRsvp(): Observable<any> {
    const obs = this.rsvpComponent.addRsvp()
      .catch((error) => {
        return error;
      });

    obs.subscribe(() => {
      this.isAddRsvpCollapsed = true;
    });

    return obs;
  }

  cancelAddRsvp() {
    this.rsvpComponent.cancelEditRsvp();
    this.isAddRsvpCollapsed = true;
  }

  handleUploadError(errorMessage: string, logMessage: string = null) {
    this.isUploadInProgress = false;
    this.flashMessagesService.error(errorMessage, logMessage);
  }

  openUploadBulkRsvp() {
    this.rsvpBulk.open();
  }

  /**
   * This needs to be called whenever we do an upload so that someone could do a second upload with a different file
   * without having to reload the page.
   */
  clearFileInput(): void {
    this.fileInput.nativeElement.value = null;
  }

  disableSave() {
    let disable: boolean;
    if (this.rsvpComponent && this.rsvpComponent.rsvpForm) {
      disable = !this.rsvpComponent.rsvpForm.valid;
    } else {
      disable = true;
    }
    return disable;
  }

  getRsvpReport(fileType: string) {
    this.reportService.getRsvpReport(this.onyxEvent.eventId, fileType, this.summarySelected)
      .subscribe(blob => {
        let filename = ResponseUtil.getFileNameFromHttpResponse(blob);
        if (!filename) {
          const reportType = this.summarySelected ? ReportType.RSVP_SUMMARY : ReportType.RSVP_COMPARE;
          filename = this.reportService.buildReportFileName(reportType, this.onyxEvent, fileType);
        }
        saveAs(blob.body, filename);
      });
  }

  downloadRsvpCompare(): void {
    this.getMatches(MatchTypeEnum.NO_MATCH).take(1).subscribe(noMatchesListResponse => {
      const noMatchesList = noMatchesListResponse;
      this.getMatches(MatchTypeEnum.PARTIAL_MATCH).take(1).subscribe(partialMatchesListResponse => {
        const partialMatchesList = partialMatchesListResponse;
        this.getMatches(MatchTypeEnum.EXACT_MATCH).take(1).subscribe(exactMatchesListResponse => {
          const exactMatchesList = exactMatchesListResponse;
          this.pdfService.downloadRsvpCompare(this.onyxEvent, noMatchesList, partialMatchesList, exactMatchesList);
        });
      });
    });
  }

  getMatches(matchType: MatchTypeEnum): Observable<List<ReservationCompare>> {
    return this.rsvpCompareList.map((comparisonList: List<ReservationCompare>) => {
      const list = comparisonList.filter((comparison: ReservationCompare) => comparison.matchType === matchType.toString()).toList();
      return list;
    });
  }

  displayAddRsvp(): boolean {
    return this.isAddRsvpCollapsed && (!this.hasFinalPayment || this.isRequestPaymentRejected);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/rsvp/add-rsvp/add-rsvp.component.ts